import $ from "jquery";

$(".tribe-events-single-event-title").wrap(
  '<div class="tribe-events-single-event-title-wrap"></div>'
);

$(".tribe-events-back").addClass("make-green");
$(".tribe-events-schedule").addClass("make-green");
$(".tribe-events-notices").addClass("make-green");

$(".single-tribe_events .tribe-events-back a").attr("href", "/news-events/");
